import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, from } from 'rxjs';
import {Alarm, MonitoredTrain} from '../models/monitored-train';
import { environment } from '../../../../environments/environment';
import { TrainSyncData } from '../models/train-sync-data';
import { map } from 'rxjs/operators';
import { PreprocessingMonitoredTrainService } from './preprocessing-monitored-train.service';
import { TrainEvent } from '../models/trainEvent';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Injectable({
  providedIn: 'root'
})
export class FaultMonitoringDataService {

  constructor(
    private http: HttpClient,
    private preprocessingMonitoredTrainService: PreprocessingMonitoredTrainService
  ) { }

  getAllTrains = (projectId: number, usedFields?: string) :  Observable<MonitoredTrain[]> => {
    return this.http.get<MonitoredTrain[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainsList}?projectId=${projectId}`)
    .pipe(map(trains => this.preprocessingMonitoredTrainService.trainList(trains) ))
  }

  getTrain = (projectId: number, trainId: number) :  Observable<MonitoredTrain> => {
    return this.http.get<MonitoredTrain>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainsList}/${trainId}?projectId=${projectId}`)
    .pipe(map(train => this.preprocessingMonitoredTrainService.singleTrain(train) ))
  }

  getTrainSynchronisation = (projectId: number, trainId: number) :  Observable<TrainSyncData[]> => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
    .set('trainId', trainId.toString());
    return this.http.get<TrainSyncData[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainSync}`, {params});
  }

  acknowledgeAlarms = (projectId: number, trainId: number, type: string, eventIds: number[]): Promise<any> => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
    .set('type', type)
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.zabbix}/acknowledge/${trainId}`, eventIds , {params}).toPromise();
  }

  getCdcAlarms = (projectId: number): Observable<MonitoringAlarm[]> => {
      const params = new HttpParams()
          .set('projectId', projectId.toString());
      return this.http.get<MonitoringAlarm[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.cdcAlarms}`, {params});
  }

  getTrainEvents = (projectId: number, trainId?: number) => {
    const params = new HttpParams()
    .set('projectId', projectId.toString());
    if (trainId) {
      return this.http.get<TrainEvent[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainEvents}/${trainId}`, {params});
    } else {
      return this.http.get<TrainEvent[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainEvents}`, {params});
    }
    

   /* EventResource.getTrainEvents().query({
      'projectId': projectId,
      'trainId': trainId
  }).$promise.then(function (data) {
      vm.events = data && data.map(function (event) {
         var message = event.message.replace(/_/g, " ")
          event.message = message.replace('mar3_', '')
          return event;
      })
      vm && vm.tableParamsEvents && vm.tableParamsEvents.reload();
  });*/

  }

}
